import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  coachees: [],
  total: 0,
  page: 0,
  count: 20
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/coacheeTracker/vuex/index.js